import {SidepanelSection} from 'constants/NavConstants';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import {getStore} from 'redux-stores/Store';
import {SearchUISelector} from 'search/reduceSearchUI';
import {GLOBAL_SEARCH_URL, SearchType} from 'search/SearchConstants';

interface CurrentSearchInfo {
  section: SidepanelSection | null;
  searchType: SearchType | null;
  apiCall: string | null;
}

export default function getCurrentSearchInfo(): CurrentSearchInfo {
  const selector = new SearchUISelector(getStore().getState());
  const section = SidepanelStore.getSection();
  if (section == null) {
    return {section, searchType: null, apiCall: null};
  }

  const state = selector.getSearchSessionState(section);
  if (state === undefined || state.searchId == null) {
    return {section, searchType: null, apiCall: null};
  }

  const searchType = selector.getTypeForSearch(state.searchId);
  return {section, searchType, apiCall: GLOBAL_SEARCH_URL};
}

export function getCurrentSearchId(): string | undefined {
  const selector = new SearchUISelector(getStore().getState());
  const section = SidepanelStore.getSection();
  return section != null ? selector.getSearchSessionState(section)?.searchId : undefined;
}
